import { ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { Box, TableCell, TableRow } from "@mui/material";
import { Link } from "react-router";
import { useTranslation } from "@localization/useTranslation";
import ReadOnlyTableDialog from "@common/components/readOnlyTableDialog/ReadOnlyTableDialog";
import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider";
import { useUrlProvider } from "../../../../useUrlProvider";
import PolicyVersionBadge from "../../../../policy/common/PolicyVersionBadge";
import { FrameworkControlPolicy } from "../FrameworkControlOverview.types";

export interface IAnchoredPoliciesDialog {
    policies: Array<FrameworkControlPolicy>;
    onDialogClose: () => void;
}

export default function AnchoredPoliciesDialog(props: IAnchoredPoliciesDialog) {
    const { translateString } = useTranslation();
    const { getPolicyUrl } = useUrlProvider();
    const { permissions } = useUserContext();

    const headers: Array<ITableHeader<FrameworkControlPolicy>> = [
        { property: "name", text: translateString("policy"), align: "left", showOnMobile: true },
        { property: "version", text: translateString("version"), align: "left", showOnMobile: true },
    ];

    return (
        <ReadOnlyTableDialog
            header={translateString("anchoredInPolicies")}
            emptyText={translateString("noData")}
            headers={headers}
            data={props.policies}
            defaultOrderBy={"name"}
            clickableRows={false}
            hover={false}
            onDialogClose={props.onDialogClose}
            renderRow={(row) => (
                <TableRow key={row.policyId}>
                    <TableCell>
                        {permissions.policyPermissions.read ? (
                            <Box component={Link} sx={{ textDecoration: "none" }} to={getPolicyUrl(row.policyId)}>
                                <Box
                                    sx={(theme) => ({
                                        color: theme.palette.primary.main,
                                        fontWeight: theme.typography.fontWeightBold,
                                        "&:hover": {
                                            textDecoration: "underline",
                                        },
                                    })}
                                >
                                    {row.name}
                                </Box>
                            </Box>
                        ) : (
                            row.name
                        )}
                    </TableCell>
                    <TableCell>
                        <PolicyVersionBadge version={row.version} isDraft={false} />
                    </TableCell>
                </TableRow>
            )}
        />
    );
}
